/** Tiny monospace pill that surfaces a stable, human-readable reference
 * (e.g. `TEST-7`, `SUITE-3`) next to an entity name. Renders nothing when
 * the ref is missing so legacy docs degrade cleanly.
 *
 * Styled to **stand out** — blue tinted background + bold blue text — since
 * the reference is the single most useful field for cross-team comms (paste
 * "TEST-18 is flaky" into Slack and everyone knows what you mean).
 */
export function RefBadge({ value, testId }) {
  if (!value) return null;
  return (
    <span
      data-testid={testId || "ref-badge"}
      className="inline-flex items-center w-fit self-start font-mono font-semibold text-[11px] uppercase tracking-wide text-[#2563EB] bg-[#EFF6FF] border border-[#BFDBFE] rounded px-1.5 py-[1px] dark:text-[#93C5FD] dark:bg-[#1E3A8A]/30 dark:border-[#3B82F6]/40"
      title={value}
    >
      {value}
    </span>
  );
}
